import NFT from './ABI/BattleGrowlies_metadata.json'


export default {
    BG: {ABI: NFT.output.abi, Address: "0x9880600FA50BFe433d70435757e189C87378F5f9"},
}
